
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"40","viewBox":"0 0 41 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.832 24.064C19.688 24.064 19.568 24.016 19.472 23.92C19.376 23.824 19.328 23.704 19.328 23.56V22.6C19.36 21.752 19.576 21.024 19.976 20.416C20.376 19.808 20.96 19.112 21.728 18.328C22.352 17.688 22.808 17.16 23.096 16.744C23.384 16.328 23.528 15.872 23.528 15.376C23.528 14.64 23.216 14.056 22.592 13.624C21.984 13.192 21.272 12.976 20.456 12.976C18.552 12.976 17.432 13.936 17.096 15.856C17.016 16.208 16.808 16.384 16.472 16.384H15.32C15.16 16.384 15.032 16.336 14.936 16.24C14.84 16.144 14.792 16.016 14.792 15.856C14.824 14.976 15.072 14.168 15.536 13.432C16.016 12.68 16.688 12.08 17.552 11.632C18.416 11.184 19.408 10.96 20.528 10.96C21.712 10.96 22.704 11.168 23.504 11.584C24.32 11.984 24.92 12.512 25.304 13.168C25.688 13.808 25.88 14.496 25.88 15.232C25.88 16.048 25.696 16.752 25.328 17.344C24.96 17.936 24.408 18.624 23.672 19.408C23.064 20.048 22.608 20.592 22.304 21.04C22 21.472 21.824 21.96 21.776 22.504C21.744 22.952 21.728 23.288 21.728 23.512C21.648 23.88 21.448 24.064 21.128 24.064H19.832ZM19.64 28C19.48 28 19.344 27.952 19.232 27.856C19.136 27.744 19.088 27.608 19.088 27.448V25.984C19.088 25.824 19.136 25.696 19.232 25.6C19.344 25.488 19.48 25.432 19.64 25.432H21.2C21.36 25.432 21.496 25.488 21.608 25.6C21.72 25.696 21.776 25.824 21.776 25.984V27.448C21.776 27.608 21.72 27.744 21.608 27.856C21.496 27.952 21.36 28 21.2 28H19.64Z"}})])
          )
        }
      }
    